import React from 'react'
import EditIndividualMembersForm from '../../features/viewIndividualMember/EditIndividualMembersForm'

const EditIndividualMembers = () => {
    return (<EditIndividualMembersForm />)
}

export default EditIndividualMembers